<c11n-nav-overflow class="d-block d-sm-none" [menuData]="menuData"
                   [triggerLabel]="'Actions'"
                   [direction]="'below'"
                   (selectItemEvent)="onMessageNavigationMenu($event)"
                   [externalLabel]="true"></c11n-nav-overflow>

<c11n-nav-overflow class="d-none d-md-block d-lg-none" [menuData]="menuDataForMediumScreen"  *ngIf="selectedMessageDetails"
                   [triggerLabel]="'Actions'"
                   [direction]="'below'"
                   (selectItemEvent)="onMessageNavigationMenu($event)"
                   [externalLabel]="true"></c11n-nav-overflow>
